import type React from "react";
import { useEffect } from "react";
import { useRouter } from "solito/router";
import { FullscreenSpinner, isWeb, usePathname, YStack } from "@medbillai/ui";
import { getStartedUrl, webSignUpOnboardingUrl, webSignUpOnboardingUsageScopeUrl, webSignUpOnboardingUserNeedsUrl } from "@medbillai/utils/urls";
import { GrantedWordmark } from "../../components/local-images/LocalImages";
import { analyticsService } from "../../lib/analytics/analytics";
import { useAuth } from "../../lib/auth";
const skipSignUpOnboardingUrls = [webSignUpOnboardingUrl(), getStartedUrl(), webSignUpOnboardingUserNeedsUrl(), webSignUpOnboardingUsageScopeUrl()];
export type SignUpOnboardingLayoutProps = {
  maxWidth?: number;
  children?: React.ReactNode;
};
export const SignUpOnboardingLayout = ({
  children
}: SignUpOnboardingLayoutProps) => {
  const pathname = usePathname();
  const router = useRouter();
  const {
    isAuthenticated,
    isReady
  } = useAuth();

  // If the user is authenticated and the pathname is a skip sign up onboarding
  // url, we need to redirect them to the home page so they are not stuck on the
  // sign up onboarding flow.
  useEffect(() => {
    if (isAuthenticated && isReady && skipSignUpOnboardingUrls.includes(pathname)) {
      router.replace("/");
    } else if (pathname === webSignUpOnboardingUrl()) {
      // Track the start of the sign up onboarding flow.
      analyticsService.trackEvent("SignUpOnboardingFlowStarted", {
        onboardingVersion: "v1.0"
      });
    }
  }, [isAuthenticated, isReady, pathname, router]);

  // Show spinner if not ready or if we're about to redirect authenticated users
  if (!isReady || isAuthenticated && isReady && skipSignUpOnboardingUrls.includes(pathname)) {
    return <FullscreenSpinner />;
  }
  return <YStack f={1} overflow="hidden" $platform-web={{
    height: "100vh"
  }} backgroundColor="$surface1" data-sentry-element="YStack" data-sentry-component="SignUpOnboardingLayout" data-sentry-source-file="layout.web.tsx">
      {children}
      {isWeb ? <YStack position="absolute" top="$sp2" left="$sp2.5" height="$si4" justifyContent="center" pointerEvents="none" zIndex={1}>
          <GrantedWordmark />
        </YStack> : null}
    </YStack>;
};